export default __webpack_public_path__ + "static/media/Screen Shot 2022-05-09 at 2.54.08 PM.c3166e71.png";